module.exports = __webpack_public_path__ + "static/media/5.e66243cd.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/5.wav
// module id = 57
// module chunks = 0